import {z} from 'zod';

import i18n from '@dms/i18n';

export const AMOUNT_TYPE_OPTIONS = [
  'SMALLUNITMATERIAL_FROM_MATERIAL',
  'SMALLUNITMATERIAL_FROM_LABOUR',
  'SMALLUNITMATERIAL_FROM_MATERIAL_LABOUR',
] as const;

export const workshopSmallUnitMaterialDetailSchema = z
  .object({
    name: z.string().min(1, {message: i18n.t('general.errors.mixed.required')}),
    orderVariantIds: z.array(z.string()).min(1, {message: i18n.t('general.errors.mixed.required')}),
    amountType: z.enum(AMOUNT_TYPE_OPTIONS),
    amountValue: z.number().min(1).max(100),
    isMaxValue: z.boolean(),
    maxValue: z.number().min(0).optional().nullable(),
  })
  .superRefine((data, ctx) => {
    if (data.isMaxValue && (data.maxValue === null || data.maxValue === undefined)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['maxValue'],
        message: i18n.t('general.errors.mixed.required'),
      });
    }
  });

export type WorkshopSmallUnitMaterialDetailFormType = z.infer<
  typeof workshopSmallUnitMaterialDetailSchema
>;
